
export * from './repositories/dialogs.repository';
export * from './services/dialogs.service';
export * from './dialogs.module';
export * from './model/model';

export * from './components/dialogs-completion-page/dialogs-completion-page';
export * from './components/dialogs-detail-page/dialogs-detail-page';
export * from './components/dialogs-list-page/dialogs-list-page';
export * from './components/dialogs-questions-page/dialogs-questions-page';

